import { memoize } from 'lodash-es';

const initializeRUM = async () => {
  const { AwsRum } = await import('aws-rum-web');

  return new AwsRum(
    '961029ea-4196-407a-bd47-20f0345dc359',
    '1.0.0',
    'us-west-2',
    {
      sessionSampleRate: 1,
      guestRoleArn: 'arn:aws:iam::360415357614:role/prod-us-west-2-GrowThrive-GTCHubprodRUMIdentityPool-fBCuHf8LOJX7',
      identityPoolId: 'us-west-2:4b3772b4-ea9d-4cf4-b48e-259ee1a5ca92',
      endpoint: `https://dataplane.rum.us-west-2.amazonaws.com`,
      telemetries: [
        'performance',
        'errors',
        ['http', { recordAllRequests: true }],
      ],
      allowCookies: true,
      sessionEventLimit: 0,
      enableXRay: true,
      enableRumClient: true,
      // https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/CloudWatch-RUM-custom-metadata.html
      sessionAttributes: {
        userAgent: navigator.userAgent,
      },
    },
  );
};

// https://github.com/aws-observability/aws-rum-web/blob/main/docs/configuration.md
export const getAwsRumInstance = memoize(initializeRUM);
